/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Formats_TitleInputs */

const en_mcp_cap_formats_title = /** @type {(inputs: Mcp_Cap_Formats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No guessing what works`)
};

const es_mcp_cap_formats_title = /** @type {(inputs: Mcp_Cap_Formats_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin adivinar qué funciona`)
};

/**
* | output |
* | --- |
* | "No guessing what works" |
*
* @param {Mcp_Cap_Formats_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_formats_title = /** @type {((inputs?: Mcp_Cap_Formats_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Formats_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_formats_title(inputs)
	return en_mcp_cap_formats_title(inputs)
});